import React, {useContext} from 'react';

import {Group, Item} from '@pb/kit-component-group';
import {LocaleContext} from '@pb/kit-context-locale';

import {getDate} from '../utils';

import {apiV2ChangesInfo} from './changes-info.module.styl';

import type {LocaleContextType} from '@pb/kit-context-locale';
import type {ChangesInfo as ChangesInfoType} from 'src/openapi/admin/models/ChangesInfo';

type Props = {
    data?: ChangesInfoType,
};
export const ChangesInfo = (props: Props) => {
    const {data} = props;

    const {locale} = useContext<LocaleContextType>(LocaleContext);

    if (!data) {
        return null;
    }

    const {createdBy, createdAt, updatedBy, updatedAt} = data;

    return (
        <Group className={apiV2ChangesInfo} direction="v" gap="xxs" alignItems="start">
            <Item>
                {createdBy && createdAt ? `Created By: ${createdBy} ${getDate(createdAt, locale)}` : null}
            </Item>
            <Item>
                {updatedBy && updatedAt ? `Last Edited By: ${updatedBy} ${getDate(updatedAt, locale)}` : null}
            </Item>
        </Group>
    );
};
